export const LocalStorageKey = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info'
};

export const ENUM_ROLE = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE'
};

export const ENUM_TYPE_MESS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
};

export const CONST_SYS = {
  PASS_RESET: '@@okvip@@'
};

export const CONST_SITE = {
  SHBET: 'shbet',
  NEW88: 'new88'
};

export const LIST_SITE = [
  {
    key: CONST_SITE.SHBET,
    name: CONST_SITE.SHBET
  },
  {
    key: CONST_SITE.NEW88,
    name: CONST_SITE.NEW88
  }
];

export const SETTING_KEYS = {
  TITLE: 'title',
  NO_DATA: 'no-data',
  PRIZE_STRUCTURE: 'prize_structure',
  PRIZE_STRUCTURE_LOTTERY: 'lottery_reward',
  PRIZE_STRUCTURE_ESPORT: 'prize_esport_structure',
  LOGIN_URL: 'link_login',
  REGISTER_URL: 'link_register'
};
